import React from 'react';

interface BrowserCompatWrapperProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  as?: keyof JSX.IntrinsicElements;
}

/**
 * Wrapper component to ensure compatibility with older browsers (especially Chrome 109 and earlier)
 * by providing a stable DOM node instead of React Fragments.
 * 
 * This prevents DOMException: Failed to execute 'removeChild' errors that occur when:
 * - Browser extensions modify the DOM (TransOver, Google Translate, etc.)
 * - React tries to remove fragment nodes that don't exist in older browser engines
 * - Strict mode operations conflict with extension DOM modifications
 */
export const BrowserCompatWrapper: React.FC<BrowserCompatWrapperProps> = ({ 
  children, 
  className,
  style,
  as: Element = 'div'
}) => {
  const wrapperStyle: React.CSSProperties = {
    // Minimal styling to avoid layout impact
    display: 'contents',
    ...style
  };

  return React.createElement(Element, { className, style: wrapperStyle }, children);
};

export default BrowserCompatWrapper;